import { TransparencyPortalLinkType } from "../../../types/types";
import { api } from "../api";

/**
 * Invalida o link atual do portal da transparência e gera um novo.
 * /transparency-portal/link/regenerate?customerId={customerId}
 */
const regenerateTransparencyPortalLink = async (token: string, customerId?: number) => {
    return api.post<TransparencyPortalLinkType>("/transparency-portal/link/regenerate", null, {
        params: { customerId },
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export default regenerateTransparencyPortalLink;
